import { ReactNode } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

interface ModalPopupProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  children: ReactNode;
  showFooter?: boolean;
  footerButtons?: {
    label: string;
    variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning';
    onClick: () => void;
  }[];
  size?: 'sm' | 'lg' | 'xl';
  centered?: boolean;
}

const ModalPopupComponent = ({
  show,
  onHide,
  title = '',
  children,
  showFooter = true,
  footerButtons = [],
  size,
  centered = true,
}: ModalPopupProps) => {
  return (
    <Modal show={show} onHide={onHide} size={size} centered={centered}>
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body style={{ padding: '20px' }}>{children}</Modal.Body>
      {showFooter && footerButtons.length > 0 && (
        <Modal.Footer style={{justifyContent:'center'}}>
          {footerButtons.map((button, index) => (
            <Button
              key={index}
              variant={button.variant || 'primary'}
              onClick={button.onClick}
            >
              {button.label}
            </Button>
          ))}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalPopupComponent;